var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.425 2.5H9.5875C5.35 2.5 2.5 5.475 2.5 9.9V20.1125C2.5 24.525 5.35 27.5 9.5875 27.5H20.425C24.6625 27.5 27.5 24.525 27.5 20.1125V9.9C27.5 5.475 24.6625 2.5 20.425 2.5Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.5 15C22.5 19.1421 19.1421 22.5 15 22.5C10.8579 22.5 7.5 19.1421 7.5 15C7.5 10.8579 10.8579 7.5 15 7.5C19.1421 7.5 22.5 10.8579 22.5 15ZM9 15C9 18.3137 11.6863 21 15 21C18.3137 21 21 18.3137 21 15C21 11.6863 18.3137 9 15 9C11.6863 9 9 11.6863 9 15Z",
    fill: "#E5B910"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.75C15 22.1642 14.6634 22.5039 14.2512 22.4625C13.1898 22.356 12.1602 22.024 11.2328 21.4852C10.0886 20.8206 9.14061 19.865 8.48505 18.7156C7.8295 17.5661 7.48973 16.2637 7.50024 14.9405C7.51074 13.6172 7.87115 12.3204 8.54487 11.1815C9.21859 10.0426 10.1816 9.10217 11.3363 8.45576C12.4909 7.80935 13.796 7.47994 15.1191 7.50095C16.4422 7.52196 17.7361 7.89264 18.8697 8.57539C19.7884 9.12876 20.5752 9.87117 21.1797 10.7502C21.4144 11.0915 21.2788 11.55 20.9158 11.7495V11.7495C20.5528 11.949 20.1004 11.8129 19.8572 11.4776C19.386 10.8278 18.7876 10.2771 18.0957 9.86031C17.1889 9.31412 16.1537 9.01756 15.0953 9.00076C14.0368 8.98395 12.9927 9.24748 12.069 9.76461C11.1453 10.2817 10.3749 11.034 9.83589 11.9452C9.29692 12.8563 9.00859 13.8938 9.00019 14.9524C8.99178 16.0109 9.2636 17.0529 9.78804 17.9725C10.3125 18.892 11.0709 19.6565 11.9863 20.1882C12.6847 20.5939 13.4556 20.8531 14.2519 20.9532C14.6629 21.0048 15 21.3358 15 21.75V21.75Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickYellow);
export default __webpack_public_path__ + "static/media/tick-yellow.027054128bc2ef5fc5ff79688b9f95a7.svg";
export { ForwardRef as ReactComponent };